import styled, { css } from 'styled-components';

const Panel = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`;

type TPanelHeader = {
  noBottomPadding?: boolean;
};

const PanelHeader = styled.div<TPanelHeader>(
  ({ theme, noBottomPadding }) => css`
    padding: 60px 80px 45px;

    ${noBottomPadding &&
    css`
      padding-bottom: 0px !important;
    `};

    @media (max-width: ${theme.breakpoints.max.lg}) {
      padding: 60px 60px 45px;
    }

    @media (max-width: ${theme.breakpoints.max.md}) {
      padding: 45px;
    }

    @media (max-width: ${theme.breakpoints.max.sm}) {
      padding: 45px 30px 30px;
    }
  `
);

const PanelContent = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.main.background};
    padding: 45px 80px 60px;
    flex-grow: 1;

    @media (max-width: ${theme.breakpoints.max.lg}) {
      padding: 45px 60px 60px;
    }

    @media (max-width: ${theme.breakpoints.max.md}) {
      padding: 45px;
    }

    @media (max-width: ${theme.breakpoints.max.sm}) {
      padding: 45px 30px 30px;
    }
  `
);

export { Panel, PanelHeader, PanelContent };
